import React from 'react'
import { observer } from 'mobx-react'
import { LayerGroup } from 'react-leaflet'
import UserShapefileLayerShape from './UserShapefileLayerShape'

// Renders "preview" shapes when a user selects items
// while browsing an uploaded shapefile.
const UserShapefileLayer = ({ userShapefileList }) => (
  <LayerGroup>
    {
      userShapefileList.selectedLevel &&
      userShapefileList.selectedLevel.preview
        ? (
          // When a layer's `preview` boolean is true,
          // preview all shapes
            userShapefileList.selectedLevel.shapes.map(shape => (
              shape.geoJSON && (
                <UserShapefileLayerShape
                  key={shape.id}
                  userShapefileList={userShapefileList}
                  shape={shape}
                />
              )
            ))
          )
        : (
          // When a layer's `preview` boolean is false,
          // preview only the selected shape (if there is one)
            userShapefileList.selectedShape &&
          userShapefileList.selectedShape.geoJSON && (
            <UserShapefileLayerShape
              userShapefileList={userShapefileList}
              shape={userShapefileList.selectedShape}
            />
            )
          )
    }
  </LayerGroup>
)

export default observer(UserShapefileLayer)
